import { AccountDetailsIcon } from './AccountDetailsIcon';

/**
 * author: Google
 * id 3696B7DF-3E12-44EF-B27F-E171AEB5241F
 * name account-details
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-details.svg
 * tags
 * - Account / User 
 * - Settings 
 */
export const UserDetailsIcon = AccountDetailsIcon;
export default UserDetailsIcon